export const adminAssessments = {
    PersonalityTestCategory: ['Driver', 'Analytical', 'Amiable', 'Expressive'],
    CultureFitCategory: ['Clan', 'Market', 'Adhocracy', 'Hierarchy'],
    SoftSkillsCategory: ['Communication', 'Problem Solving', 'Relationship Building', 'Adaptability']
}